import DealRepository from "./repositories/dealRepository";
import ColumnRepository from "./repositories/columnRepository";
import TemplateRepository from "./repositories/templateRepository";
import GroupRepository from "./repositories/groupRepository";
import PresetRepository from "./repositories/presetRepository";
import UserRepository from "./repositories/userRepository";
import DeviceRepository from "./repositories/deviceRepository";
import FormatRepository from "./repositories/formatRepository";
import PlacementRepository from "./repositories/placementRepository";
import SalesofficeRepository from "./repositories/salesofficeRepository";
import BrandingRepository from "./repositories/brandingRepository";
import DealTypeRepository from "./repositories/dealTypeRepository";
import DeallistRepository from "@/scripts/repositories/deallistRepository";

const repositories = {
    deals: DealRepository,
    columns: ColumnRepository,
    templates: TemplateRepository,
    groups: GroupRepository,
    presets: PresetRepository,
    users: UserRepository,
    devices: DeviceRepository,
    formats: FormatRepository,
    placements: PlacementRepository,
    salesoffices: SalesofficeRepository,
    brandings: BrandingRepository,
    dealTypes: DealTypeRepository,
    deallist: DeallistRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};